import { t } from '../i18n'

export const REFERRALS = {
  warning: t('constants.referrals.warning'),
  fullStop: t('constants.referrals.fullStop'),
  manualAction: t('constants.referrals.manualAction'),
} as const
